import(/* webpackMode: "eager" */ "/app/apps/web-app/src/app/global-error.tsx");
